import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { api } from '../lib/api';

interface ActiveGame {
  gameId: string;
  code: string;
  phase: 'lobby' | 'playing';
  playerCount: number;
  maxPlayers: number;
}

interface State {
  active: ActiveGame | null;
  /** True while we're verifying with the server. */
  loading: boolean;
  set: (g: ActiveGame | null) => void;
  refresh: () => Promise<void>;
  clear: () => void;
}

export const useActiveGame = create<State>()(
  persist(
    (set) => ({
      active: null,
      loading: false,
      set: (g) => set({ active: g }),
      clear: () => set({ active: null }),
      refresh: async () => {
        set({ loading: true });
        try {
          const g = await api.myGame();
          set({ active: g, loading: false });
        } catch {
          set({ loading: false });
        }
      },
    }),
    { name: 'durak-active-game' },
  ),
);
